export var ErrorEnum;
(function (ErrorEnum) {
    ErrorEnum["GENERIC"] = "genericError";
    ErrorEnum["REGISTRATION_INVALID_COLLECTIVE"] = "registrationInvalidCollectiveIdError";
    ErrorEnum["REGISTRATION_ERROR"] = "registrationError";
    ErrorEnum["PASSWORD_RESET"] = "passwordResetError";
    ErrorEnum["PAGE_NOT_FOUND"] = "pageNotFoundError";
    ErrorEnum["USER_NOT_IN_COLLECTIVE"] = "userNotInCollective";
    ErrorEnum["USER_PROFILE"] = "userProfileError";
    ErrorEnum["USER_TOKEN_RESET_PASSWORD_EXPIRED"] = "tokenResetPasswordExpiredError";
    ErrorEnum["PAYMENTS_PAGE"] = "paymentsPageError";
    ErrorEnum["PAYMENTS_KO"] = "paymentsKOPageError";
})(ErrorEnum || (ErrorEnum = {}));
